import { Machine } from '../types/machine';

export const getMachineLabel = (m: Machine) => {
  const driverName = m.assignedDriverName ?? '';
  return (
    `${m.internalNumber} - ${m.subCategoryName} - ${m.modelName}${driverName && ` - ${driverName}`}`
  );
};
